import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js';
import {Offcanvas} from 'bootstrap';

export default class AddToCart extends HTMLButtonElement {
    connectedCallback() {
        // Champ Quantité
        this.inputQuantity = this.dataset.inputQuantityId
            ? document.querySelector(`#${this.dataset.inputQuantityId}`)
            : null;

        // Événements
        this.initEvents();
    }

    /**
     * Événements.
     */
    initEvents() {
        // Click sur le boutton d'ajout au panier
        this.addEventListener('click', (e) => {
            e.preventDefault();
            if ( ! this.disabled) {
                this.addToCart();
            }
        }, true);
    }

    /**
     * Lance la requête d'ajout au panier.
     */
    addToCart() {
        const requestor = new Requestor();
        requestor.sendRequest(this.dataset.href, 'POST', {
            product_id: this.getProductId(),
            quantity: this.getCartQuantity() * this.dataset.caissage,
            return_templates: ['common.link-to-cart-icon', 'common.offcanvas-add-cart-confirmation-content']
        }, (data) => {
            this.refreshTemplates(data.templates);
            this.showConfirmation();
        });
    }

    /**
     * Quantité à ajouter au panier.
     */
    getCartQuantity() {
        return this.inputQuantity
            ? (this.inputQuantity.value ? parseInt(this.inputQuantity.value) : 0)
            : 1;
    }

    /**
     * Identifiant du produit à ajouter au panier.
     */
    getProductId() {
        return this.dataset.productId;
    }

    /**
     * Remplace le contenu des éléments identifiés par un attribut data-template
     * à partir des éléments passés en paramètre.
     * @param templates
     */
    refreshTemplates(templates) {
        if (typeof templates === 'object') {
            for (const [name, content] of Object.entries(templates)) {
                if (typeof content !== 'string') { return; }
                const els = document.querySelectorAll(`[data-template="${name}"]`);
                for (const el of els) {
                    el.innerHTML = content;
                }
            }
        }
    }

    showConfirmation() {
        this.offcanvas = Offcanvas.getOrCreateInstance('#offcanvas-add-to-cart');
        this.offcanvas.show();
    }
}
